import * as AllSagas from './sagas';
export const Sagas = Object.values(AllSagas);
export * from './actionsPublic';
export { default as reducer } from './reducer';

export interface LoadSpinnerState {
    LoadingKeys: string[];
}